export function useJobRequestConfiguration(workplaceAllowsInterviewRequest: boolean) {
  return {
    enabled: workplaceAllowsInterviewRequest,
    maxInterviewsDatesToSelect: 3,
    maxInterviewsDatesToBeShown: 7,
  };
}
